export const turmaJson = {
    "code": "T01",
    "codeInep": null,
    "name": "1º ANO",
    "typeMediation": 0,
    "daysWeek": {
        "sunday": null,
        "monday": null,
        "tuesday": null,
        "wednesday": null,
        "thursday": null,
        "friday": null,
        "saturday": null
    },
    "workingPlace": -1,
    "codeCourse": 0,
    "alternationFormation": -1,
    "aggregateStage": 0,
    "stage": 0,
    "specialEducationClass": -1,
    "typeServices": {
        "curricularStage": 0,
        "complementaryActivity": 0,
        "specializedEducationalService": 0
    },
    "multi": 0,
    "complementaryActivity": {
        "code1": 0,
        "code2": 0,
        "code3": 0,
        "code4": 0,
        "code5": 0,
        "code6": 0
    },
    "formsOrganization": {
        "seriesYear": 0,
        "semesterPeriods": 0,
        "cycles": 0,
        "noSerialGroup": 0,
        "modules": 0,
        "regularAlternationPeriods": 0
    },
    "formativeArea":{
        "languagesTechnologies": 0,
        "mathematicsTechnologies": 0,
        "scienceTechnologies": 0,
        "humanScience": 0
    },
    "curricularOrganization": {
        "basicGeneralFormation": 0,
        "deepFormativeItinerary": 0,
        "professionalFormativeItinerary": 0
    },
    "curricularComponents": {
        "chemical": -1,
        "physical": -1,
        "mathematics": -1,
        "biology": -1,
        "sciences": -1,
        "portugueseLanguage": -1,
        "englishLanguage": -1,
        "spanishLanguageCC": -1,
        "anotherForeignLanguage": -1,
        "art": -1,
        "physicalEducation": -1,
        "history": -1,
        "geography": -1,
        "philosophy": -1,
        "informaticsComputing": -1,
        "customKnowledgeAreas": -1,
        "librasCC": -1,
        "areasPedagogicalKnowledge": -1,
        "religiousEducation": -1,
        "indigenousLanguageCC": -1,
        "socialStudies": -1,
        "sociology": -1,
        "frenchLanguageCC": -1,
        "portugueseSecondLanguage": -1,
        "supervisedInternship": -1,
        "lifeProjectCC": -1,
        "otherAreasKnowledge": -1
    },
    "bilingualEducationClassDeaf": -1,
    "wasChanged": false,
    "inepRelation": ""
}
